export const BACK_END_URL =
  process.env.REACT_APP_API_URL || "https://riikka.dev.gala.one/back_office";
// export const BACK_END_URL = "http://localhost";
